<template><div><h1 id="outputverwaltung" tabindex="-1"><a class="header-anchor" href="#outputverwaltung"><span>Outputverwaltung</span></a></h1>
<p>Outputverwaltung — Ansicht und Ausführung von Print-Output-Jobs</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Maske können die einzelnen Jobs angezeigt und zusätzliche Aktionen, wie Dokument erstellen oder drucken, ausgeführt werden.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Outputverwaltung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Export-Dat</dt>
<dd>Datum des XML-Rohdatenexports</dd>
<dt>Job-ID</dt>
<dd>Identifikations-ID des Jobs</dd>
<dt>Dokumentensatz</dt>
<dd><a class="link" href="ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</a></dd>
<dt>St</dt>
<dd>Job-Status
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>DR</td>
<td>Output-Dokumente gedruckt</td>
</tr>
<tr>
<td>EX</td>
<td>XML-Rohdaten exportiert</td>
</tr>
<tr>
<td>LL*</td>
<td>Output-Dokumente und XML-Rohdaten gelöscht</td>
</tr>
<tr>
<td>LO</td>
<td>XML-Rohdaten gelöscht</td>
</tr>
<tr>
<td>LX*</td>
<td>Output-Dokumente gelöscht</td>
</tr>
<tr>
<td>PR</td>
<td>Dokument erstellt, nicht gedruckt</td>
</tr>
<tr>
<td>F1</td>
<td>Fehler beim Export</td>
</tr>
<tr>
<td>F2</td>
<td>Fehler im Pre-Prozess</td>
</tr>
<tr>
<td>F3</td>
<td>Fehler in der Transformation</td>
</tr>
<tr>
<td>F4</td>
<td>Fehler in der Formatierung</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<ul>
<li>Diese Stati werden gesetzt, wenn mindestens 1 Dokument aus einem Dokumentensatz gelöscht worden ist.</li>
</ul>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>ausführen</dt>
<dd>Je nach Ausgangsstatus können mit dieser Funktion Outputs erstellt und/oder Dokumente gedruckt werden.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


